// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SellBrushPopup.css */

.sell-overlay-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1500;
  touch-action: none; /* Отключаем стандартные жесты на фоне */
  overscroll-behavior: none; /* Отключаем прокрутку за пределами */
  -webkit-user-select: none; /* Отключаем выделение текста */
  user-select: none;
}



.sell-brush-popup {
  position: fixed;
  max-height: 95vh; 
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  background-color: var(--tg-theme-bg-color);
  padding: 20px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1600;
  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-x: hidden;
}

.sell-brush-title {
  color: var(--tg-theme-button-color);
  font-size: 22px;
  margin-bottom: 5px;
  text-align: center;
  width: 100%;
}

.sell-brush-preview {
  width: 300px;
  height: 150px;
  border: 1px solid var(--tg-theme-hint-color);
  border-radius: 8px;
  margin-bottom: 0px;
}

.sell-parameter-button {
  height: 32px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.sell-brush-about {
  width: 100%;
  min-height: 35px; 
  height: 35px; 
  padding: 8px;
  margin-bottom: 5px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid var(--tg-theme-hint-color);
  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  font-size: 16px;
  resize: vertical; /* Разрешаем менять только высоту */
}


.sell-brush-controls {
  display: flex;
  width: 100%;
  gap: 10px;
  margin-bottom: 15px;
  align-items: center;
}


.sell-parameter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.sell-brush-label {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  color: var(--tg-theme-text-color);
  padding: 3px; 
  padding-left: 10px; 
}

.sell-brush-slider {
  flex: 1 1;
  height: 20px;
  background: var(--tg-theme-button-color);
  opacity: 0.7;
  border-radius: 5px;
}

.sell-brush-price-input {
  width: 70px;
  padding: 8px;
  border-radius: 8px;
  border: 2px solid var(--tg-theme-button-color);
  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  font-size: 16px;
  text-align: center;
}

.sell-brush-price-input:focus {
  outline: none;
  border-color: #00BB00;
}

`, "",{"version":3,"sources":["webpack://./src/components/menus/brush/SellBrushPopup.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,kBAAkB,EAAE,wCAAwC;EAC5D,yBAAyB,EAAE,qCAAqC;EAChE,yBAAyB,EAAE,+BAA+B;EAC1D,iBAAiB;AACnB;;;;AAIA;EACE,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,gBAAgB,EAAE,mCAAmC;AACvD;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB","sourcesContent":["/* SellBrushPopup.css */\r\n\r\n.sell-overlay-background {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1500;\r\n  touch-action: none; /* Отключаем стандартные жесты на фоне */\r\n  overscroll-behavior: none; /* Отключаем прокрутку за пределами */\r\n  -webkit-user-select: none; /* Отключаем выделение текста */\r\n  user-select: none;\r\n}\r\n\r\n\r\n\r\n.sell-brush-popup {\r\n  position: fixed;\r\n  max-height: 95vh; \r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 300px;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 20px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1600;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n\r\n  overflow-x: hidden;\r\n}\r\n\r\n.sell-brush-title {\r\n  color: var(--tg-theme-button-color);\r\n  font-size: 22px;\r\n  margin-bottom: 5px;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n.sell-brush-preview {\r\n  width: 300px;\r\n  height: 150px;\r\n  border: 1px solid var(--tg-theme-hint-color);\r\n  border-radius: 8px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.sell-parameter-button {\r\n  height: 32px;\r\n  margin: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.sell-brush-about {\r\n  width: 100%;\r\n  min-height: 35px; \r\n  height: 35px; \r\n  padding: 8px;\r\n  margin-bottom: 5px;\r\n  box-sizing: border-box;\r\n  border-radius: 2px;\r\n  border: 1px solid var(--tg-theme-hint-color);\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  font-size: 16px;\r\n  resize: vertical; /* Разрешаем менять только высоту */\r\n}\r\n\r\n\r\n.sell-brush-controls {\r\n  display: flex;\r\n  width: 100%;\r\n  gap: 10px;\r\n  margin-bottom: 15px;\r\n  align-items: center;\r\n}\r\n\r\n\r\n.sell-parameter-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.sell-brush-label {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  color: var(--tg-theme-text-color);\r\n  padding: 3px; \r\n  padding-left: 10px; \r\n}\r\n\r\n.sell-brush-slider {\r\n  flex: 1;\r\n  height: 20px;\r\n  background: var(--tg-theme-button-color);\r\n  opacity: 0.7;\r\n  border-radius: 5px;\r\n}\r\n\r\n.sell-brush-price-input {\r\n  width: 70px;\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  border: 2px solid var(--tg-theme-button-color);\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  font-size: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.sell-brush-price-input:focus {\r\n  outline: none;\r\n  border-color: #00BB00;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
